import { fmtEUR, fmtDate } from "@/lib/api";
import { shortConcept } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { SortableHead } from "./shared";

export function IgnoredTable({ rows, totalCount, canAct, focusTx, sort, clickSort, onRestore }) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <SortableHead label="Fecha" sortKey="date" defDir="desc" sort={sort} clickSort={clickSort} testid="recon-sort-ignored-date" />
              <SortableHead label="Concepto" sortKey="concept" sort={sort} clickSort={clickSort} testid="recon-sort-ignored-concept" />
              <SortableHead label="Cuenta" sortKey="account" sort={sort} clickSort={clickSort} testid="recon-sort-ignored-account" />
              <SortableHead label="Importe" sortKey="amount" sort={sort} clickSort={clickSort} testid="recon-sort-ignored-amount" right />
              <TableHead className="text-right"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((tx) => (
              <TableRow key={tx.id} data-testid={`recon-ignored-${tx.id}`}
                className={tx.id === focusTx ? "bg-amber-50 ring-1 ring-amber-300" : undefined}>
                <TableCell className="text-sm">{fmtDate(tx.date)}</TableCell>
                <TableCell className="text-sm max-w-96 truncate" title={tx.concept}>{shortConcept(tx.concept)}</TableCell>
                <TableCell className="text-xs text-slate-500">{tx.account_name}</TableCell>
                <TableCell className={`text-right font-num font-semibold ${tx.amount >= 0 ? "text-green-700" : "text-red-700"}`}>
                  {fmtEUR(tx.amount)}
                </TableCell>
                <TableCell className="text-right">
                  {canAct && (
                    <Button data-testid={`recon-restore-${tx.id}`} size="sm" variant="outline" onClick={() => onRestore(tx.id)}>
                      Restaurar a pendientes
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {totalCount === 0 && rows.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center py-10 text-slate-400 text-sm">
                No hay movimientos ignorados.
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
